// The player URL for an allowlisted video (design.md, "Rich content" ->
// "Video"). The server already validates provider and id (and the database
// CHECKs them), but this string becomes an iframe src, so it is re-validated
// here with the same strict shapes: an unknown provider or an id that is not
// exactly the expected charset yields null and the card just opens the link.
//
// Autoplay is on because these URLs are only built after the user taps the
// play button; nothing loads a third-party player before that. YouTube uses
// the privacy-enhanced (no-cookie) host and Vimeo's do-not-track flag.
const YOUTUBE_ID = /^[A-Za-z0-9_-]{11}$/;
const VIMEO_ID = /^[0-9]{6,12}$/;

export function embedPlayerUrl(embed: { provider: string; id: string }): string | null {
  if (embed.provider === 'youtube' && YOUTUBE_ID.test(embed.id)) {
    return `https://www.youtube-nocookie.com/embed/${embed.id}?autoplay=1&rel=0&playsinline=1`;
  }

  if (embed.provider === 'vimeo' && VIMEO_ID.test(embed.id)) {
    return `https://player.vimeo.com/video/${embed.id}?autoplay=1&dnt=1`;
  }

  return null;
}
